import { AnchorTagBuilder, AbstractMatch, EmailMatch } from "autolinker";
import { parseCustomMatches } from "./match.util";

// RFC 5322 compliant regex found in https://uibakery.io/regex-library/email
export const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
export function parseEmailMatches(src: string, tagBuilder: AnchorTagBuilder, existingMatches: AbstractMatch[]): EmailMatch[] {
  return parseCustomMatches(emailRegex, src, existingMatches, (match, index) => new EmailMatch({
    tagBuilder: tagBuilder,
    matchedText: match,
    offset: index,
    email: match
  }));
}